// actions.js

export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = 'ADD_TO_CART_FAILURE';
export const FINANCE_AMOUNT_REQUEST = 'FINANCE_AMOUNT_REQUEST';
export const FINANCE_AMOUNT_SUCCESS = 'FINANCE_AMOUNT_SUCCESS';
export const FINANCE_AMOUNT_FAILURE = 'FINANCE_AMOUNT_FAILURE';
